import { setContext } from '@apollo/client/link/context';
import { IS_DEVELOPMENT } from '@/lib/constants';
import { logger as globalLogger } from '@/logger';

const HEADER_NAME = 'Idempotency-Key';
const logger = globalLogger.getLogger('apollo/idempotency');

export const IdempotencyLink = setContext(
  (operation, context: ApolloContext) => {
    if (
      !context.headers?.[HEADER_NAME] &&
      operation.query.definitions.some(
        (definition) =>
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'mutation',
      )
    ) {
      const idempotencyKey = crypto.randomUUID();

      if (IS_DEVELOPMENT) {
        logger.trace(`Set '${HEADER_NAME}' to '${idempotencyKey}'`);
      }

      return {
        ...context,
        headers: {
          ...context.headers,
          [HEADER_NAME]: idempotencyKey,
        },
      };
    }

    return context;
  },
);
